import { Usuario } from '@/types/users/usuario';
import { types } from '../types/types';

interface UserReducerState {
  users: Usuario[];
  agencies: any[];
  active: any;
}

const initialState: UserReducerState = {
  users: [],
  agencies: [],
  active: null,
};

export const userReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case types.currentUser:
      return {
        ...state,
        current: {
          ...action.payload,
        },
      };
    case types.userActive:
      return {
        ...state,
        active: {
          ...action.payload,
        },
      };
    case types.usersLoad:
      return {
        ...state,
        users: [...action.payload],
      };
    case types.agenciesLoad:
      return {
        ...state,
        agencies: [...action.payload],
      };

    case types.usersDelete:
      return {
        ...state,
        active: null,
        users: state.users.filter(user => user.PkUsuarios !== action.payload),
      };
    case types.usersLogOutCleaning:
      return initialState;

    case types.userSyncNemon:
      return {
        ...state,
        active: action.payload,
      };

    default:
      return state;
  }
};
